var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tab as MuiTab, Tabs as MuiTabs } from '@mui/material';
import { useEffect, useState } from 'react';
var Tabs = function (_a) {
    var tab = _a.tab, tabs = _a.tabs, disable = _a.disable, onChange = _a.onChange;
    var _b = useState(0), tabIndex = _b[0], setTabIndex = _b[1];
    var handleTabChange = function (_event, newTabIndex) {
        setTabIndex(newTabIndex);
        onChange === null || onChange === void 0 ? void 0 : onChange(tabs[newTabIndex].key);
    };
    useEffect(function () {
        var index = tabs.findIndex(function (t) { return t.key === tab; });
        setTabIndex(index > -1 ? index : 0);
    }, []);
    return (_jsx(MuiTabs, __assign({ value: tabIndex, onChange: handleTabChange }, { children: tabs.map(function (_a) {
            var label = _a.label, disabled = _a.disabled;
            return (_jsx(MuiTab, { disabled: disable || disabled, disableRipple: true, label: label }, label));
        }) })));
};
export default Tabs;
